import PrimaryButton from "components/buttons/primary-button";
import GrayCard from "components/gray-card";
import Typography from "components/typography";

import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const VideoStores = () => {
  const stores = ["Apple Musiic", "Tidal", "VEVO"];
  return (
    <Container>
      <GrayCard
        fullWidth
        title="Stores"
        headerButtonComponent={
          <PrimaryButton
            text="Edit Stores"
            iconPosition="left"
            variant="text"
            iconSize="1.6"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M9.32206 3.56396L9.84106 3.0449C10.7011 2.1849 12.0954 2.1849 12.9554 3.0449C13.8154 3.90489 13.8154 5.29922 12.9554 6.15922L12.4363 6.67827M9.32206 3.56396C9.32206 3.56396 9.3869 4.66694 10.3601 5.64017C11.3334 6.61339 12.4363 6.67827 12.4363 6.67827M9.32206 3.56396L4.55013 8.33586C4.22692 8.65909 4.06532 8.82065 3.92634 8.99884C3.76238 9.20907 3.62183 9.43648 3.50714 9.67711C3.40992 9.88112 3.33765 10.098 3.1931 10.5316L2.5806 12.3691M12.4363 6.67827L7.66445 11.4502C7.34122 11.7734 7.17966 11.935 7.00147 12.074C6.79126 12.2379 6.56382 12.3785 6.32318 12.4932C6.11919 12.5904 5.90237 12.6626 5.46874 12.8072L3.63123 13.4197M2.5806 12.3691L2.43088 12.8183C2.35975 13.0316 2.41529 13.2669 2.57434 13.426C2.7334 13.585 2.96867 13.6406 3.18206 13.5695L3.63123 13.4197M2.5806 12.3691L3.63123 13.4197"
                  stroke="currentColor"
                  stroke-width="0.980001"
                />
              </svg>
            }
          />
        }
      >
        <StoreGrid>
          {stores.map((store, i) => {
            return (
              <Store key={i}>
                <Typography color={Colors.grey600}>•</Typography>
                <Typography ml="0.8" color={Colors.grey400}>
                  {store}
                </Typography>
              </Store>
            );
          })}
        </StoreGrid>
      </GrayCard>
    </Container>
  );
};

export default VideoStores;

const Container = styled.div`
  width: 100%;
`;

const StoreGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 2.4rem;
`;

const Store = styled.div`
  display: flex;
`;
